import type { ServiceLinkEntry } from "@/lib/serviceLinkTypes";

/**
 * Batch 74 — "Filipino virtual assistant — operational & management" cluster
 * service links.
 *
 * Each Batch 74 article routes its primary commercial link to the automation
 * service page that matches its angle (Zapier/Make for time-zone & retention,
 * n8n for direct-vs-agency, HubSpot for interview/vetting, CRM for
 * onboarding). The answer-first leads in batch74Content.ts embed the link
 * directly, but the lead-swap idempotency guard can drop the lead when the
 * Quick Answer duplicates the lead text. This map is the RELIABLE fallback:
 * `injectBatchServiceLink` (batchContentOptimizer.ts) wraps the first in-body
 * occurrence of each anchor phrase in the service-page link, so the contextual
 * service link always renders regardless of the lead swap.
 *
 * Anchors are distinctive body phrases (not in the H1) so the link injects
 * into the article body, never the headline.
 */
export const BATCH74_SERVICE_LINKS: Record<string, ServiceLinkEntry> = {
  "filipino-virtual-assistant-time-zone-overlap": {
    url: "/zapier-make-automation-expert",
    anchor:
      /VA who waits for the morning handoff is a hire the team bottlenecks at the gap/i,
    label: "hire a Zapier and Make automation expert",
  },
  "hire-filipino-virtual-assistant-direct-vs-agency": {
    url: "/n8n-workflow-developer",
    anchor: /direct VA with no screening is a hire the team rekeys/i,
    label: "hire an n8n workflow developer",
  },
  "filipino-virtual-assistant-interview-questions": {
    url: "/hubspot-revops-architect",
    anchor:
      /VA who aces the soft questions but cannot build a workflow is a hire the team rekeys/i,
    label: "hire a HubSpot RevOps architect",
  },
  "filipino-virtual-assistant-onboarding-checklist": {
    url: "/CRM-revops-architect",
    anchor: /VA with access and no map is a hire the team rekeys/i,
    label: "hire a CRM RevOps architect",
  },
  "filipino-virtual-assistant-retention-strategy": {
    url: "/zapier-make-automation-expert",
    anchor:
      /VA who builds the same workflows for the same rate for two years is a hire the team loses to the market/i,
    label: "hire a Zapier and Make automation expert",
  },
};
